import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "16 17 21 12 16 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "21", x2: "9", y1: "12", y2: "12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LogOut";
const LogOut = memo(themed(Icon));
export {
  LogOut
};
//# sourceMappingURL=log-out.js.map
